document.addEventListener('DOMContentLoaded',function(){
  document.querySelectorAll('.vam').forEach(function(root){
    var sticky=root.querySelector('.vam-sticky');
    if(!sticky)return;
    var update=function(){sticky.classList.toggle('is-visible',window.scrollY>550)};
    update();window.addEventListener('scroll',update,{passive:true});
  });

  function setupReviewFeed(){
    var feed=document.querySelector('.valora-adv-millions-review-section .vam-review-list');
    if(!feed||feed.dataset.vamReviewLoader==='ready')return;
    var originals=Array.prototype.slice.call(feed.querySelectorAll('.vam-review'));
    if(!originals.length)return;
    feed.dataset.vamReviewLoader='ready';
    var observer;
    var last=originals[originals.length-1];

    function appendBatch(){
      if(observer)observer.disconnect();
      var shuffled=originals.slice();
      for(var i=shuffled.length-1;i>0;i--){
        var j=Math.floor(Math.random()*(i+1));
        var item=shuffled[i];shuffled[i]=shuffled[j];shuffled[j]=item;
      }
      var fragment=document.createDocumentFragment();
      shuffled.forEach(function(card){
        var copy=card.cloneNode(true);
        [copy].concat(Array.prototype.slice.call(copy.querySelectorAll('*'))).forEach(function(node){
          node.removeAttribute('id');
          Array.prototype.slice.call(node.attributes).forEach(function(attribute){
            if(attribute.name.indexOf('data-shopify')===0)node.removeAttribute(attribute.name);
          });
        });
        copy.classList.add('vam-review--revealed');
        fragment.appendChild(copy);
      });
      feed.appendChild(fragment);
      last=feed.lastElementChild;
      observeLast();
    }

    function observeLast(){
      if(!('IntersectionObserver' in window))return;
      observer=new IntersectionObserver(function(entries){
        if(entries.some(function(entry){return entry.isIntersecting}))appendBatch();
      },{rootMargin:'0px 0px 600px 0px'});
      observer.observe(last);
    }
    if('IntersectionObserver' in window){
      observeLast();
    }else{
      window.addEventListener('scroll',function(){
        if(last.getBoundingClientRect().top<window.innerHeight+600)appendBatch();
      },{passive:true});
    }
  }
  setupReviewFeed();
  document.addEventListener('shopify:section:load',setupReviewFeed);
});

